import useInterventionRepository from "../../../../repository/insurance/useInterventionRepository";
import {useEffect} from "react";
import Intervention from "../../../../entity/insurance/Intervention";
import isNull from "../../../../mixin/isNull";
import Box from "@mui/material/Box";
import {CircularProgress} from "@mui/material";
import StepQuotationAppointment from "./step/quotation-appointment/StepQuotationAppointment";
import StepTravel from "./step/travel/StepTravel";
import StepPictureBefore from "./step/picture-before/StepPictureBefore";
import StepQuotation from "./step/quotation/StepQuotation";
import StepQuotationValidation from "./step/quotation-validation/StepQuotationValidation";
import StepQuotationSignature from "./step/quotation-signature/StepQuotationSignature";
import StepWorksAppointment from "./step/work-appointment/StepWorkAppointment";
import StepWorks from "./step/work/StepWork";
import StepPictureAfter from "./step/picture-after/StepPictureAfter";
import StepReportCompletion from "./step/report-completion/StepReportCompletion";
import StepReportCompletionSignature from "./step/report-completion-signature/StepReportCompletionSignature";
import Terminate from "./step/terminate/Terminate";
import UpdateQuotation from "./update-quotation/UpdateQuotation";

export default function ({interventionId, clientId, orderId, updateQuotation, onQuotationUpdated}) {
    const interventionRepository = useInterventionRepository();
    /** @type Intervention */
    const intervention = interventionRepository.findOneById(interventionId).select();

    useEffect(() => {
        interventionRepository.findOneById(interventionId).exec();
    }, []);

    const getStep = () => {
        if (updateQuotation) {
            return <UpdateQuotation
                interventionId={interventionId}
                orderId={orderId}
                onQuotationUpdated={onQuotationUpdated}
            />;
        }

        switch (intervention.getCurrentStep()) {
            case Intervention.STEP_INITIALIZED:
                return <StepQuotationAppointment interventionId={interventionId} clientId={clientId}
                                                 orderId={orderId}/>;
            case Intervention.STEP_QUOTATION_APPOINTMENT:
                return <StepTravel interventionId={interventionId} clientId={clientId}/>;
            case Intervention.STEP_TRAVEL:
                return <StepPictureBefore interventionId={interventionId}/>;
            case Intervention.STEP_PICTURE_BEFORE:
                return <StepQuotation interventionId={interventionId} orderId={orderId} clientId={clientId}/>;
            case Intervention.STEP_QUOTATION:
            case Intervention.STEP_QUOTATION_FAIRFAIR_VALIDATION:
                return <StepQuotationValidation interventionId={interventionId}/>;
            case Intervention.STEP_QUOTATION_PRESCRIBER_VALIDATION:
                return <StepQuotationSignature interventionId={interventionId}/>;
            case Intervention.STEP_QUOTATION_SIGNATURE:
                return <StepWorksAppointment interventionId={interventionId} clientId={clientId}/>;
            case Intervention.STEP_WORKS_APPOINTMENT:
                return <StepWorks interventionId={interventionId}/>;
            case Intervention.STEP_WORKS:
                return <StepPictureAfter interventionId={interventionId}/>;
            case Intervention.STEP_PICTURE_AFTER:
                return <StepReportCompletion interventionId={interventionId}/>;
            case Intervention.STEP_REPORT_COMPLETION:
                return <StepReportCompletionSignature interventionId={interventionId}/>;
            case Intervention.STEP_REPORT_COMPLETION_SIGNATURE:
                return <Terminate interventionId={interventionId}/>;
        }

        return "not found";
    }

    if (isNull(intervention)) {
        return (
            <Box display="flex" justifyContent="center" mt={20}>
                <CircularProgress/>
            </Box>
        );
    }

    return getStep();
}
